import { useCheckboxGroup } from '@react-aria/checkbox'
import React from 'react'
import type { CheckboxGroupState } from 'react-stately'
import { useCheckboxGroupState } from 'react-stately'
import { StyledLabel } from '../Form/Form.styles'
import type { CheckboxGroupProps } from './CheckboxGroup.types'

export const CheckboxGroupContext =
  React.createContext<CheckboxGroupState | null>(null)

/**
 * Checkbox groups allow users to select multiple items from a list of options.
 *
 * Supported components: <NextTile role="checkbox">.
 *
 * @since 11.6.0
 */
export const CheckboxGroup = React.forwardRef<
  HTMLDivElement,
  CheckboxGroupProps
>(function CheckboxGroup({ disabled, ...props_ }, ref) {
  const props = { ...props_, isDisabled: disabled }
  const state = useCheckboxGroupState(props)

  const { groupProps, labelProps } = useCheckboxGroup(props, state)

  return (
    <div {...groupProps}>
      {props.label != null ? (
        typeof props.label === 'string' ? (
          <StyledLabel {...labelProps}>{props.label}</StyledLabel>
        ) : (
          <div {...labelProps}>{props.label}</div>
        )
      ) : null}
      <CheckboxGroupContext.Provider value={state}>
        {props.children}
      </CheckboxGroupContext.Provider>
    </div>
  )
})
